import React from 'react'
import { Link } from 'react-router'
import { prefixLink } from 'gatsby-helpers'
import {FaInstagram, FaFacebook, FaTwitter, FaEnvelopeO} from 'react-icons/lib/fa'
import SocialA from './styled/SocialA'

const Component = React.createClass({
  render: function() {
    const style = {
      ...this.props.style,
      display: 'flex',
      justifyContent: 'flex-end',
      fontSize: '1.5rem',
      marginTop: '5rem',
    }

    const aStyle = {
      textDecoration: 'none'
    }

    const iconStyle = {
      marginLeft: '2rem'
    }

    return (<div>
      <footer style={style}>
        <SocialA
          href='https://www.instagram.com/dasprojectco/'
          target='_blank'
          style={aStyle}
          title='dasProject Instagram'
        >
          <FaInstagram style={iconStyle} />
        </SocialA>
        <SocialA
          href='https://www.facebook.com/dasprojectco/'
          target='_blank'
          style={aStyle}
          title='dasProject Facebook'
        >
          <FaFacebook style={iconStyle} />
        </SocialA>
        <SocialA
          href='https://twitter.com/dasprojectco/'
          target='_blank'
          style={aStyle}
          title='dasProject Twitter'
        >
          <FaTwitter style={iconStyle} />
        </SocialA>
        <SocialA
          href='mailto:hi@dasproject.co'
          target='_blank'
          style={aStyle}
          title='dasProject Mail'
        >
          <FaEnvelopeO style={iconStyle} />
        </SocialA>
      </footer>
    </div>)
  }
})

// <p><Link style={{
//     float: 'right',
//     marginTop: '1.5rem',
//     color: 'gray',
//     textDecoration: 'none'
//   }} to={prefixLink('/impressum/')}>Impressum</Link></p>

export default Component



// WEBPACK FOOTER //
// ../components/SocialBar.js